import React from "react";
import { View, Text, ScrollView, Pressable } from "react-native";

interface LogEntry {
  time: string;
  type: string;
}

interface HoursLogProps {
  logEntries: LogEntry[];
}

export default function HoursLog({ logEntries = [] }: HoursLogProps) {
  const sortedEntries = [...logEntries].sort(
    (a, b) => new Date(b.time).getTime() - new Date(a.time).getTime()
  );

  return (
    <View className="bg-white rounded-xl p-4 mb-4 border border-gray-200 flex-100 max-h-[333px]">
      <Text className="text-lg font-semibold text-gray-800 mb-2">🕒 Hours Log</Text>

      {logEntries.length === 0 ? (
        <Text className="text-gray-500 text-center">No logs available</Text>
      ) : (

        <ScrollView className="" showsVerticalScrollIndicator={false}>
          <Pressable>
            {sortedEntries.map((entry, index) => {
              let indicatorColor = "bg-gray-400";

              if (entry.type.includes("ClockIn")) indicatorColor = "bg-green-500";
              if (entry.type.includes("ClockOut")) indicatorColor = "bg-red-500";
              if (entry.type.includes("BreakOut")) indicatorColor = "bg-orange-400";
              if (entry.type.includes("BreakIn")) indicatorColor = "bg-orange-300";
              if (entry.type.includes("LunchOut")) indicatorColor = "bg-yellow-500";
              if (entry.type.includes("LunchIn")) indicatorColor = "bg-cyan-300";

              return (
                <View key={index} className="flex-row items-center bg-gray-100 rounded-lg p-3 mb-3">
                  <View className={`w-2 h-full rounded-lg ${indicatorColor}`} />
                  <View className="pl-4 flex-1">
                    <Text className="text-gray-600 text-sm">
                      {entry.type.replace(/([A-Z])/g, " $1").trim()}
                    </Text>
                    <Text className="text-lg font-bold text-gray-800">
                      {entry.time ? new Date(entry.time).toLocaleTimeString() : "No Time"}
                    </Text>
                  </View>
                </View>
              );
            })}

          </Pressable>
        </ScrollView>

      )}
    </View>
  );
}